<template>
<v-card >

  <v-system-bar height="30" class='hidden-sm-and-up' dense flat dark >
    <v-btn :disabled='step===0' @click='step--' icon >
      <v-icon>chevron_left</v-icon>
    </v-btn>
    <v-spacer/>
    <v-btn icon
      :disabled='!canNext'
      @click='step++' >
      <v-icon>chevron_right</v-icon>
    </v-btn>
  </v-system-bar>
  <component :is='layoutComponent' :step.sync='step' >

    <v-card flat dark tile height='100%' class='pb-4' slot='step-0' >
      <slot name="ag-filters" >
      <appointment-filters mini require-daterange
        title='Find appointments'
        v-model='filters'
        :with-icon='false'
        :with-theme-toggle='false'
        :compact='compact'
        :touch='filterTouch'
        :page-size.sync='pageSize'
        :num-results='appointments.length'
        :practitioner-id='computedPractitionerId'
        :relationship='relationship'
        :initial-relationship='initialRelationship'
        :multiple-relationships='false'
        :relationship-statuses="statuses.split(',')"
        @update:relationship='setRelationship'
        @count='setCount'
        class='mx-2' >

        <template v-if='componentName === "CreateInvoice"' slot="actions" >
          <v-switch dense
            v-if='infoIsTeamAccount'
            v-model='withPersonalFilter'
            class='mb-0 mx-4' label='Only my appointments' />
          <v-switch dense v-model='withPaid' class='my-0 mx-4' label='Include paid appointments' />
          <v-switch dense v-model='withInvoiced' class='my-0  mx-4' label='Include previously invoiced appointments' />
          <v-switch dense v-model='oldestFirst' class='my-0 mx-4' label='Oldest first' />
        </template>

      </appointment-filters>
      </slot>
    </v-card>

    <template slot='step-1' >
      <!-- <pre v-text="$store.state.application.spaces.secondaryGlobalDialog" /> -->
      <!-- {{initialFilters}} | {{params}} -->
      <v-dialog v-model='showinvoicedetails' fullscreen >
        <invoice-details
          v-if='selectedAppointment'
          :with-create='false'
          v-model='selectedAppointment'
          @finalprice='dirty=true'
          @close='showinvoicedetails=false' />
      </v-dialog>

      <tombstone v-if='appointmentsLoading' />
      <div v-show='appointmentsLoading===false' >
        <appointment-list dense with-select-all
          v-if='relationship && relationship.id'
          :selected.sync='appointments'
          title='Choose appointments'
          :cards.sync="cardView"
          :with-price='false'
          :page-size='pageSize'
          :loading.sync='appointmentsLoading'
          :relationship='relationship'
          :relationship-statuses='statuses'
          :with-action='false'
          :with-actions='false'
          :multiple='true'
          :params='params'
          :touch='listTouch' >

          <template v-if="filters && filters.after_utc"
            slot="top" >
            <v-system-bar dark >
              <v-btn @click="launchDateRangePicker" icon small >
              <v-icon small class='mr-2 pl-3' >event</v-icon>
              </v-btn>
              {{filters.after_utc}} - {{filters.before_utc}}
            </v-system-bar>
            <!-- <pre>{{filters}}</pre> -->
          </template>
          <template v-slot:listaction="appt" >
            <v-btn
              @click.stop='selectedAppointment=appt.appointment;showinvoicedetails=true'
              icon small >
              <v-icon>edit</v-icon>
            </v-btn>
          </template>
        </appointment-list>

        <v-card v-else
          class='ma-3 blue lighten-5' >
          <v-card-title class='subheading' >
            <v-icon>arrow_left</v-icon>
            {{ activeComponent.step1Instructions.title }}
          </v-card-title>
          <v-card-text>
            <ul>
            <li v-for='li in activeComponent.step1Instructions.bullets' :key='li' v-text='li '/>
            </ul>
          </v-card-text>
        </v-card>
      </div>
      <v-card-actions class='hidden-sm-and-up' >
        <v-spacer/>
        <v-btn :disabled='!canNext' @click='step++' color='primary' >next</v-btn>
      </v-card-actions>
    </template>
    <!-- <v-flex xs12 sm4 class='pl-0 pt-0' style='border-left:solid 1px #ccc;' > -->
    <template slot='step-2' >
      <v-card flat
        v-if='relationship && relationship.id && appointments && appointments.length > 0' >
        <template >
          <v-card-title class='overline grey lighten-4 py-2'
            v-if='activeComponent && activeComponent.title' >
            <v-icon class='mr-2 small'
              v-if='activeComponent.icon' >{{activeComponent.icon}}</v-icon>
            {{activeComponent.title}}
            <v-spacer></v-spacer>
              <v-icon @click='reset' small >close</v-icon>
          </v-card-title>
          <v-divider v-if='activeComponent && activeComponent.title' />
          <component
            :is='activeComponent.component'
            :relationship='relationship'
            :appointments='appointments'
            v-bind='activeComponent.attrs'
            @close='listTouch++;appointments=[];step=0;$emit("close")'
            @done='listTouch++;appointments=[];step=0;$emit("close")'
            @next='appointments=[];listTouch++;filterTouch++;step=0;'
            @success='$emit("success")' />
        </template>
      </v-card>
      <v-card v-else class='ma-3 blue lighten-5' >
        <v-card-title class='subheading' >
          <v-icon>arrow_left</v-icon>
          {{ activeComponent.step2Instructions.title }}
        </v-card-title>
        <v-card-text>
          <ul>
          <li v-for='li in activeComponent.step2Instructions.bullets' :key='li' v-text='li '/>
          </ul>
        </v-card-text>
      </v-card>
    </template>
  </component>
</v-card>
</template>
<script>
// import AppointmentPicker from '@/components/pickers/AppointmentPicker/index.vue'
import MobileStepLayout from '@/components/layouts/MobileStepLayout.vue'
import StepLayout from '@/components/layouts/StepLayout.vue'
import AppointmentFilters from '@/components/filters/AppointmentFilters.vue'
import AppointmentList from '@/components/lists/AppointmentList.vue'
import InvoiceDetails from '@/components/appointment/edit/InvoiceDetails'
import Tombstone from '@/components/app/Tombstone.vue'
import CreateInvoice from '@/components/invoice/manage/create/confirm.vue'
import Payment from '@/components/appointment/actions/CreateTransaction'

export default {
  name: 'AppointmentAction',
  components: {AppointmentFilters, AppointmentList, InvoiceDetails, Tombstone},
  props: {
    title: { type: String, required: false, default: 'Choose appointments' },
    componentName: { type: String, required: true },
    initialRelationship: { type: Object, required: false, default: null },
    initialFilters: { type: Object, required: false },
    compact: { type: Boolean, default: false },
    touch: { type: Number, default: 0 },
    pageSize: { type: Number, default: 20 }
  },
  data () {
    return {
      step: 0,
      dirty: false,
      showinvoicedetails: false,
      oldestFirst: true,
      withPaid: false,
      withInvoiced: false,
      fullscreen: false,
      withPersonalFilter: false,
      filterTouch: 0,
      listTouch: 0,
      appointmentsLoading: false,
      cardView: false,
      invoice: {},
      relationshipCount: -1,
      relationship: null,
      selectedAppointment: null,
      appointments: [],
      filters: {},
      requests: {}
    }
  },
  methods: {
    setRelationship (relationship) {
      this.relationship = relationship
      if (this.relationshipId) { this.step++ }
    },
    setCount (cnt) {
      this.relationshipCount = cnt
    },
    reset () {
      this.step = 0
      this.relationshipCount = -1
      this.appointments = []
      this.filterTouch++
      // this.setRelationship(null)
      if (this.initialRelationship) {
        this.setRelationship(this.initialRelationship)
      } else {
        this.setRelationship(null)
      }
    }
  },
  watch: {
    initialRelationship: {
      immediate: true,
      handler () {
        this.setRelationship(this.initialRelationship)
        this.listTouch++
      }
    },
    initialFilters: {
      immediate: true,
      handler () {
        this.filters = this.initialFilters
      }
    },
    secondaryspacevisible () {
      let refreshingComponents = ['AppointmentCodes']
      if (this.secondaryspace && this.secondaryspace.component) {
        let needsRefresh = refreshingComponents.indexOf(this.secondaryspace.component) >= 0
        if (this.secondaryspacevisible === false && needsRefresh) {
          this.listTouch++
        }
      }
    },
    relationshipId () {
      this.appointments = []
    },
    touch () {
      this.reset()
    },
    showinvoicedetails () {
      if (this.showinvoicedetails === true) {
        this.dirty = false
      } else {
        if (this.dirty === true) {
          this.listTouch++
        }
        this.dirty = false
      }
    }
  },
  computed: {
    canNext () {
      if (this.step === 0 && this.relationshipId) { return true }
      if (this.step === 1 && this.appointments && this.appointments.length > 0) { return true }
      return false
    },
    secondaryspace () {
      return this.$store.state.application.spaces.secondaryGlobalDialog
    },
    secondaryspacevisible () {
      return this.$store.state.application.spaces.secondaryGlobalDialog.visible
    },
    computedPractitionerId () {
      if (this.withPersonalFilter) {
        return this.meId
      }
      return null
    },
    layoutComponent () {
      if (this.$vuetify.breakpoint.xs) { return MobileStepLayout }
      return StepLayout
    },
    activeComponent () {
      return this.components[this.componentName]
    },
    relationshipId () {
      return this.getObjectPath(this.relationship, 'id', null)
    },
    initialStatuses () {
      return this.activeComponent.defaultStatuses
    },
    statuses () {
      let stats = this.initialStatuses
      if (this.withInvoiced === true) { stats += ',I' }
      if (this.withPaid === true) { stats += ',P' }
      return stats
    },
    params () {
      let params = {}
      try {
        params = JSON.parse(JSON.stringify(this.filters))
      } catch (err) {
        console.log('no filters')
      }
      if (this.relationship) {
        params.relationships = this.relationship.id
      }
      params.ordering = 'start_time'
      if (this.oldestFirst === false) {
        params.ordering = '-start_time'
      }
      if (this.withPersonalFilter) {
        params.practitioner = this.meId
      }
      params.statuses = this.statuses
      return params
    },
    components () {
      return {
        'CreateInvoice': {
          component: CreateInvoice,
          defaultStatuses: 'N,C',
          attrs: {
            value: this.invoice,
            title: 'Create invoice'
          },
          step1Instructions: {
            title: 'Step 1: Find appointments to invoice',
            bullets: [
              'Use the filters on the left to find the appointments you would like to invoice',
              'When you choose a date range, it will limit the client list to only show the clients who have appointments during that date range',
              'By default we only list appointments with New and Cancelled statuses',
              'But you can expand the search to also include previously invoiced and paid appointments'
            ]
          },
          step2Instructions: {
            title: 'Step 2: Choose the appointments to invoice',
            bullets: [
              'Click on the appointments you would like to generate an invoice for'
            ]
          }
        },
        'Payment': {
          component: Payment,
          title: 'Track payment',
          icon: 'paid',
          defaultStatuses: 'N,C,I',
          attrs: {
          },
          step1Instructions: {
            title: 'Step 1: Choose a client to track a payment for',
            bullets: [
              'Find a client from the filters on the left',
              'When you choose a date range, it will limit the client list to only show the clients who have appointments during that date range',
              'This filter expluces appointments that are already paid'
            ]
          },
          step2Instructions: {
            title: 'Step 2: Choose the appointments that are paid',
            bullets: [
              'Click on the appointments you would like to mark as paid'
            ]
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// AppointmentAction.vue?66452fb4